import React, { useState, useEffect } from 'react';
import {
    TextField,
    Button,
    Box,
    Grid,
    Typography,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow, TableCell, TableBody, Dialog, DialogContent, DialogTitle, DialogActions, Snackbar, Alert
} from '@mui/material';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import axios from 'axios';
import { tr } from 'date-fns/locale';
import {API_URL} from "./config";
import ShiftCalendar from "./components/ShiftCalendar";
import Header from "./components/Header";
import moment from "moment";
import {CancelOutlined, CheckCircleOutline, DeleteForever, EditNote, PersonAdd, Save} from "@mui/icons-material";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {useNavigate} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import MUIDataTable from "mui-datatables";

const UserManage = () => {

    const [open, setOpen] = useState(true);
    const [selectedIndex, setSelectedIndex] = React.useState("Kullanıcı Ayarları");
    const [lists, setLists] = useState([]);
    const theme = createTheme();
    const [actionSubmit, setActionSubmit] = useState(false);
    const [actionSuccess, setActionSuccess] = useState(false);
    const [name, setName] = useState("");
    const [statusText, setStatusText] = useState("");

    let navigate = useNavigate();
    const openSidebar = () => {
        setOpen(!open);
    };
    const setSelectedItem = (id) => {
        setSelectedIndex(id);
    };

    const handleClose = () => {
        setActionSubmit(false);
    };

    const handleDelete = (user) => {
        confirmAlert({
            title: "Onay",
            message: "Silmek istediğinize emin misiniz?",
            buttons: [
                {
                    label: "Evet",
                    onClick: () => {
                        deleteUser(user);
                    },
                },
                {
                    label: "Hayır",
                    onClick: () => {},
                },
            ],
        });
    };
    const deleteUser = async (id) => {
        const token = JSON.parse(localStorage.getItem("auth_token"));

        try {
            const response = await axios.delete(`${API_URL}/auth/delete/` + id, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response?.status === 200) {
                getLists();
                setActionSubmit(true);
                setActionSuccess(true);
                setStatusText("Kullanıcı silindi.");
            }
        } catch (error) {
            console.error("API hatası:", error);
            setActionSubmit(true);
            setActionSuccess(false);
            setStatusText("Kullanıcı silinemedi");
        }
    };
    const toggleUserStatus = async (id) => {
        const token = JSON.parse(localStorage.getItem("ac_auth_token"));
        console.log(id);
        try {
            const response = await axios.put(`${API_URL}/auth/users/user-status/${id}`, {id:id},{
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response?.status === 200) {
                getLists();
                setActionSubmit(true);
                setActionSuccess(true);
                setStatusText("Kullanıcı güncellendi.");
            }
        } catch (error) {
            console.error("API hatası:", error);
            setActionSubmit(true);
            setActionSuccess(false);
            setStatusText("Kullanıcı güncellenemedi");
        }
    };
    const getLists = async () => {
        const url = `${API_URL}/auth/users`;
        let token = JSON.parse(localStorage.getItem("ac_auth_token"));
        try {
            const response = await axios.get(url, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log(response.data);
            if (response?.status === 200) {
                setLists(response.data);
            }
        } catch (error) {
            setLists([]);
            console.error("API hatası:", error);
        }
    };
    useEffect(() => {
        getLists();
    }, []);
    const handlePermissionChange = (e) => {
        const { name, value } = e.target;
    };

    // table ayarları
    const columns = [
        {
            name: "id",
            label: "#",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return <span>{rowIndex}</span>;
                },
            },
        },
        {
            name: "name",
            label: "Adı Soyadı",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "email",
            label: "Eposta",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "phone",
            label: "Telefon",
            options: {
                filter: true,
                sort: false,
            },
        },
        {
            name: "city",
            label: "Şehir",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "district",
            label: "İlçe",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "doctor_or_hospital",
            label: "Kayıt Tipi",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    return value === "doctor" ? "Doktor" : "Hastane";
                },
            },
        },
        {
            name: "department",
            label: "Branş",
            options: {
                filter: true,
                sort: true,
            },
        },

        {
            name: "user_id",
            label: "Onayla/Deaktif Yap",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => {
                    let doctor=   lists.find(user => user.user_id === value);

                    return (
                        <div>
                            {
                                doctor.is_active ?
                                    <CancelOutlined
                                        color="error"
                                        onClick={() => toggleUserStatus(value)}
                                        style={{cursor: "pointer"}}
                                    /> :
                                    <CheckCircleOutline
                                        color="success"
                                        onClick={() => toggleUserStatus(value)}
                                        style={{cursor: "pointer"}}
                                    />

                            }

                        </div>


                    )


                }


            },
        },
        {
            name: "id",
            label: "Sil",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => (
                    <DeleteIcon
                        color="error"
                        onClick={() => handleDelete(value)}
                        style={{ cursor: "pointer" }}
                    />
                ),
            },
        },
    ];
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const options = {
        customHeadRender: () => null,
        filter: true,
        selectableRows: "none",
        filterType: "dropdown",
        responsive: "standard",
        rowsPerPage: 1020,
        fixedHeader: true,

        //fixedSelectColumn: true,
        tableBodyHeight: "100%",
        print: false,
        download: true,
        searchOpen: true,
        draggableColumns: {
            enabled: false,
            transitionTime: 400,
        },
        rowStyle: {
            fontSize: 9,
            lineHeight: 0.1,
        },
        downloadOptions: {
            filterOptions: {
                useDisplayedColumnsOnly: true,
                useDisplayedRowsOnly: true,
            },
        },
        viewColumns: true,
        search: true,
        rowsPerPageOptions: [5, 10, 25, 50],

        onChangeRowsPerPage(numberOfRows) {
            setRowsPerPage(numberOfRows);
        },
        onChangePage(page) {
            setPage(page);
        },
        expandableRowsOnClick: false,
        expandableRows: false,
    };

    return (
        <>
        <Header />

        <div>

                <Box
                    component="priceLists"
                    sx={{
                        p: 2,
                         width: "1000vh",
                        height: "100vh",
                    }}
                >
                    <Toolbar />

                    <p style={{ display: "block" }}>
                        <b>Kullanıcılar </b>
                    </p>


                    <ThemeProvider theme={theme}>
                        <MUIDataTable
                            title={"Kayıtlı Kullanıcılar"}
                            data={lists}
                            columns={columns}
                            options={options}
                        />
                    </ThemeProvider>
                    <Snackbar
                        open={actionSubmit}
                        autoHideDuration={3000}
                        onClose={handleClose}
                    >
                        {actionSuccess ? (
                            <Alert severity="success" sx={{ width: "100%" }}>
                                {statusText}
                            </Alert>
                        ) : (
                            <Alert severity="error" sx={{ width: "100%" }}>
                                {statusText}
                            </Alert>
                        )}
                    </Snackbar>
                </Box>


        </div>
        </>
    );
}
export default UserManage;
